export default __webpack_public_path__ + "assets/img_webp/back_icon_n_item_05.020bb1e6.png";